module.exports = __webpack_public_path__ + "img/no_calls_icon.675dc2f1.svg";